import arraySort from 'array-sort'
import dayjs from 'dayjs'

export default {
  watch: {
    'sorting.selected': {
      handler: function () {
        this.doSorting()
      },
    },
  },
  methods: {
    doSorting() {
      switch (this.sorting.selected) {
        case 'Relevancy':
          this.doRelevancySort()
          break
        case 'Featured':
          this.doFeaturedSort()
          break
        case 'A - Z':
          this.doAlphaDescSort()
          break
        case 'Z - A':
          this.doAlphaAscSort()
          break
        case 'Date':
          this.doDateSort()
          break
      }
    },
    sortByAlphaDesc(arr, prop) {
      if (arr && arr.length) {
        return arraySort(arr, prop)
      } else {
        return []
      }
    },
    sortByAlphaAsc(arr, prop) {
      if (arr && arr.length) {
        return arraySort(arr, prop).reverse()
      } else {
        return []
      }
    },
    sortByFeatured(arr) {
      if (arr && arr.length) {
        return arr.sort(this.withSortByFeatured())
      } else {
        return []
      }
    },
    sortByDateDesc(arr) {
      if (arr && arr.length) {
        return arr.sort(this.withSortByDateDesc())
      } else {
        return []
      }
    },
    withSortByFeatured() {
      return function (a, b) {
        if (a.isFeatured && b.isFeatured) {
          if ((a.featuredRank && !b.featuredRank) || a.featuredRank < b.featuredRank) return -1
          if ((b.featuredRank && !a.featuredRank) || a.featuredRank > b.featuredRank) return 1
          return a.title.localeCompare(b.title)
        } else if (a.isFeatured && !b.isFeatured) {
          return -1
        } else if (!a.isFeatured && b.isFeatured) {
          return 1
        } else {
          return a.title.localeCompare(b.title)
        }
      }
    },
    withSortByFeaturedAndDate(sortRestByDate) {
      return function (a, b) {
        if (a.isFeatured && b.isFeatured) {
          if ((a.featuredRank && !b.featuredRank) || a.featuredRank < b.featuredRank) return -1
          if ((b.featuredRank && !a.featuredRank) || a.featuredRank > b.featuredRank) return 1
          if (a.date === b.date) return 0
          if (!a.date) return 1
          if (!b.date) return -1
          return dayjs(b.date).diff(dayjs(a.date))
        } else if (a.isFeatured && !b.isFeatured) {
          return -1
        } else if (!a.isFeatured && b.isFeatured) {
          return 1
        } else {
          if (sortRestByDate) {
            if (a.date === b.date) return 0
            if (!a.date) return 1
            if (!b.date) return -1
            return dayjs(b.date).diff(dayjs(a.date))
          }
          return a.title.localeCompare(b.title)
        }
      }
    },
    withSortByDateDesc() {
      return function (a, b) {
        if (a.date === b.date) return 0
        if (!a.date) return 1
        if (!b.date) return -1
        return dayjs(b.date).diff(dayjs(a.date))
      }
    },
    withSortByFirstTwoWordsOfProp(prop) {
      return function (a, b) {
        if (a[prop].split(' ')[0] === b[prop].split(' ')[0]) {
          return a[prop].split(' ')[1]?.localeCompare(b[prop].split(' ')[1])
        } else {
          return a[prop].localeCompare(b[prop])
        }
      }
    },
    withSortByOneOfTwoProps(propA, propB) {
      return function (a, b) {
        const propToUseForA = a[propA] ? propA : propB
        const propToUseForB = b[propA] ? propA : propB
        return a[propToUseForA].localeCompare(b[propToUseForB])
      }
    },
    setSorting(sorting) {
      if (this.sorting.selected !== sorting) this.sorting.selected = sorting
      this.doSorting()
    },
    setDescSorting() {
      this.setSorting('A - Z')
    },
    setRelevancySorting() {
      this.setSorting('Relevancy')
    },
    setFeaturedSorting() {
      this.setSorting('Featured')
    },
    toggleOrderBy() {
      if (this.sorting.isOrderByDesc !== undefined)
        this.sorting.isOrderByDesc = !this.sorting.isOrderByDesc
    },
    getOrderByLiteral(isReversed = false) {
      if (this.sorting.isOrderByDesc !== undefined) {
        const options = {
          true: 'DESC',
          false: 'ASC',
        }
        const value = isReversed ? !this.sorting.isOrderByDesc : this.sorting.isOrderByDesc
        return options[value]
      }
    },
    doNonRelevancySort() {
      if (this.sorting.selected !== 'Relevancy') this.doSorting()
    },
    doRelevancySort() {},
    doFeaturedSort() {},
    doAlphaAscSort() {},
    doAlphaDescSort() {},
    doDateSort() {},
  },
}
